<div>This product has a shelf life once transferred from the {{ gvs.clientStationName() }} inventory</div>